import React from "react";
import { ErrorMessage, Field } from "formik";
import ErrorText from "components/shared/errortext/ErrorText";
import { ReactComponent as UploadIcon } from "assets/svg/upload.svg";

const UploadMultiple = (props) => {
  const {
    label,
    name,
    onChange,
    newLabel,
    ref,
    req,
    disabled,
    accept = "image/pdf/doc/docx/png/jpeg/csv",
    multiple = true, // Defaults to true for multiple file uploads
    ...rest
  } = props;

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    handleFileSelection(droppedFiles);
  };

  const handleFileSelection = async (selectedFiles) => {
    const syntheticEvent = {
      target: {
        name,
        files: selectedFiles,
      },
    };

    if (onChange) {
      await onChange(syntheticEvent);
    }
  };

  const handleFileChange = (e) => {
    handleFileSelection(e.target.files);
  };

  return (
      <>
        <label
          className="inputControl--input"
          name={name}
          {...rest}
          htmlFor={name}
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              color: "#718EBF",
              fontSize: "15px",
            }}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
          >
            <UploadIcon />
            <p>{newLabel || "Drag or click to upload files"}</p>
          </div>
          <Field name={name}>
            {({ field }) => (
              <input
                multiple={multiple}
                className="inputControl--input-file"
                onChange={handleFileChange}
                type="file"
                id={name}
                name={name}
                ref={ref}
                disabled={disabled}
                accept={accept}
              />
            )}
          </Field>
        </label>
        <ErrorMessage name={name} component={ErrorText} />
      </>
  );
};

export default UploadMultiple;
